import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Link from 'react-router/lib/Link';
import { get } from 'Language';

class MyUsers extends Component {

	state = {
		keyword: ""
	}

    componentWillMount() {
    	const { getUsers } = this.props;
    	getUsers();
    }

    onChange = (e) => {
    	const { name, value } = e.target;
    	this.setState({
    		[name]: value
    	})
    }

    submitSearch = (e) => {
    	e.preventDefault();
    	const { getUsers } = this.props;
    	getUsers({
    		email: this.state.keyword
    	});
    }

    reset = (e) => {
        e.preventDefault();
        const { getUsers } = this.props;
        getUsers();
        this.setState({
            keyword: ""
        })
    }

    render(){

    	const { users } = this.props;

		return (
			<div className="panel-custom-wrapper">
				<div className="panel panel-custom">
					<div className="panel-heading">
						{ get('MY_USERS_LINK') }

						<Link to="/profile/users/add" className="btn btn-primary pull-right btn-xs">{ get('MY_USERS_ADD_CUSTOMER_BUTTON')}</Link>
					</div>
					<div className="panel-body">
						<form onSubmit={this.submitSearch}>
						<div className="form-group">
							<div className="row">
								<div className="col-md-6">
									<input
										onChange={this.onChange}
										name="keyword"
										className="form-control"
										value={this.state.keyword}
										placeholder="Search Email"/>
								</div>
								<div className="col-md-3">
									<button className="btn btn-sm btn-primary btn-block">
                    { get('SEARCH') }
                  </button>
								</div>
                                <div className="col-md-3">
                                    <a className="btn btn-sm btn-default btn-block" href="" onClick={this.reset}>
                                      { get('RESET') }
                                    </a>
                                </div>
							</div>
						</div>
						</form>
						<table className="table table-striped">
							<thead>
								<tr>
									<th>Name</th>
									<th>Email</th>
									<th colSpan={2}>Action</th>
								</tr>
							</thead>
							<tbody>
								{ users.map(item => (
									<tr key={item.username}>
										<td>{ item.first } { item.last }</td>
										<td>{ item.email }</td>
										<td>
											<Link to={`/profile/stance/${item.username}`} className="btn btn-sm btn-success">
												{get('STANCE_WIDTH_LINK')}
											</Link>
										</td>
                                        <td>
                                            <Link to={`/profile/gripsize/${item.username}`} className="btn btn-sm btn-success">
                                                {get('GRIPSIZE_LINK')}
                                            </Link>
                                        </td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		)
	}
}

export default connect(
	state => {
		const { users } = state.myUsers;

		return {
            users
		}
	},
	actions
)(MyUsers)


// WEBPACK FOOTER //
// ./src/my-users/containers/MyUsers.js